<template>
    <div>
        <modal :title="title" :html="text"/>
    </div>
</template>

<script>
    import Modal from "../components/Modal"

    export default {
        name: 'consumption-info',
        components: {Modal},
        data () {
            return {
                title: `Informazioni sui consumi`,
                text: `
              <p>Il dato da inserire è ricavabile dalle bollette energetiche.</p>
              <p>Sono possibili 2 opzioni: si può inserire il consumo mensile assorbito mediamente dall'utenza o inalternativa il consumo complessivo annuale.</p>
              <p>a) Opzione consumo mensile: è il valore medio che si consuma mensilmente per il quale viene moltiplicata ciascuna componente di costo (quota energia, trasporto, ecc.). Per il vettore energia elettrica è la somma delle 3 componenti F1+F2+F3, per il gas è il consumo fatturato nel periodo.</p>
              <p>b) Opzione consumo annuale: è la somma di tutti i consumi mensili. Alcuni fornitori di energia riportano il dato aggregato in ciascuna bolletta, altri il dettaglio degli ultimi 12 mesi.</p>
              <p>Si consiglia di inserire l'opzione consumo annuale se si hanno consumi mensili in bolletta molto variabili (ad esempio se ci sono assorbimenti maggiori nel periodo estivo rispetto all'invernale).</p>
`
            }
        }
    };
</script>
